import React from 'react'
import PropTypes from 'prop-types'

import { ui, translate } from 'parking-react-common'

import Label from '../components/Label'

const textMapping = {
    true  : 'Yes',
    false : 'No'
}

const YesNoLabel = ({ value, t }) => (
    <Label text={ t(textMapping[value]) } intent={ value ? ui.INTENT.success : ui.INTENT.danger } />
)

YesNoLabel.propTypes = {
    value: PropTypes.bool
}

export default translate()(YesNoLabel)
